export class King {
  static getMoves(position, color, gameState) {
    const [x, y] = position;
    const moves = [];
    
    // All surrounding squares
    for (let dx = -1; dx <= 1; dx++) {
      for (let dy = -1; dy <= 1; dy++) {
        if (dx === 0 && dy === 0) continue;
        
        const newX = x + dx;
        const newY = y + dy;
        
        if (newX >= 1 && newX <= 8 && newY >= 1 && newY <= 8) {
          const targetPos = [newX, newY];
          
          if (!gameState.isOccupied(targetPos) || 
              gameState.getPieceColor(targetPos) !== color) {
            moves.push(targetPos);
          }
        }
      }
    }
    
    // TODO: Add castling logic
    return moves;
  }
}